import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=4f5a46b7&scoped=true&"
var script = {}
import style0 from "./Logo.vue?vue&type=style&index=0&id=4f5a46b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5a46b7",
  null
  
)

export default component.exports